import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui'

import { useAppAlert } from '@Components/AppAlert';
import { useGlobalAuthStore } from '@Stores/global/auth';
import history from 'utils/history';

import Form from '../components/Form';
import { TokenProvider, useTokenStore } from '../store';

const TokenForm = () => {
  const { id } = useParams()
  const { collection: { useLoad, item, reset, useSubmit } } = useTokenStore()
  const { auth: { currentSession } } = useGlobalAuthStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)

  const handleSubmit = useSubmit()

  function handleClose() {
    reset()
    history.push(`/settings/tokens`)
  }

  async function handleSubmitAndClose(payload) {
    const user = currentSession?.user
    payload.user_id = user.id

    try {
      await handleSubmit(payload)
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Token ${message}.`)
    } catch {
      handleError('Error', `Token was not saved.`)
    }

    handleClose()
  }

  if (!item) {
    return null
  }

  return <>
    <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }}
      title={item.id ? 'Edit Token' : 'Add Token'}
    >
      <Helmet title="Token" />
      <Form data={item} handleSubmit={handleSubmitAndClose} onCancel={handleClose} />
    </DefaultSheet>
  </>
}

TokenForm.propTypes = {
  match: PropTypes.object,
};

export default function TokenFormLayout() {
  return <TokenProvider>
    <TokenForm />
  </TokenProvider>
}
